import { DownloadOutlined } from '@ant-design/icons'
import { Image } from 'antd'
import { FC } from 'react'
import type { CrmIntegrationAttachment } from '../../types/crm-integration-chat.types'
import {
  attachmentImageFullUrl,
  attachmentImageSrc,
} from '../../lib/crmIntegrationAttachment'
import classes from '../../styles/crmIntegrationChat.module.css'

type CrmIntegrationIncomingImageProps = {
  att: CrmIntegrationAttachment
  photoCount: number
  index: number
  isSinglePhoto: boolean
}

const CrmIntegrationIncomingImage: FC<CrmIntegrationIncomingImageProps> = ({
  att,
  photoCount,
  index,
  isSinglePhoto,
}) => {
  const src = attachmentImageSrc(att)
  const fullHref = attachmentImageFullUrl(att)

  const alt = att.name?.trim() || 'Изображение'
  const wrapClassName = isSinglePhoto
    ? classes.bubblePhotoLink
    : classes.bubblePhotoLinkGrid
  const imageClassName = isSinglePhoto
    ? classes.bubblePhoto
    : classes.bubblePhotoGrid

  if (!src) {
    return (
      <span className={classes.bubbleAttachmentLink}>
        Изображение недоступно
      </span>
    )
  }

  const previewSrc = fullHref ?? src
  const downloadHref = fullHref ?? src

  return (
    <div className={classes.bubblePhotoWrap}>
      <Image
        wrapperClassName={wrapClassName}
        className={imageClassName}
        src={src}
        alt={alt}
        preview={{
          src: previewSrc,
        }}
        aria-label={`Открыть изображение ${index + 1} из ${photoCount}`}
      />
      <a
        className={classes.bubblePhotoDownload}
        href={downloadHref}
        target="_blank"
        rel="noopener noreferrer"
        download={att.name ?? undefined}
        aria-label={`Скачать изображение ${index + 1} из ${photoCount}`}
        onClick={(event) => {
          event.stopPropagation()
        }}
      >
        <DownloadOutlined
          aria-hidden
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </a>
    </div>
  )
}

export default CrmIntegrationIncomingImage
